import HtmlParser from 'html-react-parser';
import React from 'react';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="dei" ontouchstart>
            <SEO title="Diversity, Equity & Inclusion | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Drive comprehensive Diversity, Equity and Inclusion initiatives through analytics that surface everything from representation and pay gaps to cultural biases."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Diversity, Equity & Inclusion | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Drive comprehensive Diversity, Equity and Inclusion initiatives through analytics that surface everything from representation and pay gaps to cultural biases." />
                <meta property="og:image" content={`https://www.charthop.com/img/meta-dei-image-2.gif`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Diversity, Equity & Inclusion | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Drive comprehensive Diversity, Equity and Inclusion initiatives through analytics that surface everything from representation and pay gaps to cultural biases." />
                <meta name="twitter:image" content={`https://www.charthop.com/img/meta-dei-image-2.gif`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="intro container">
                <div className="row pt-5 pb-5 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>Build diverse and inclusive teams.</h1>
                        <p className="header-p pb-1 pt-1">Everything you need to power your Diversity, Equity and Inclusion initiatives.</p>
                        <div className="splitText"><DemoFormShort source={"product-dei-demo-header"} /></div>                        
                    </div>
                    <div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one" >
						<ReactPlayer
							url="/videos/visualize-color.mp4"
							playing
							loop
							muted
							playsinline
						/>
					</div>
                </div>
            </section>

            {/* COSTUMERS */}
            <section className="customer testimonial-container backgroundGradientContainer pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
            </section>

            {/* dashboard */}
            <section className="sectionSpacing flex-centeredColumn dashboard">
                <h2 className="text-center mt-0 sectionSpacing-Margin">The DE&I Dashboards you've always wanted</h2> 
                <div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                        <div className="svg-info-card-3col">
							<img src={'/product/people-analytics/create.svg'} alt="Insight" />
							<h3>Built for you</h3>
							<p>Leverage pre-made reports from industry experts.</p>
						</div>
                         <div className="svg-info-card-3col">
							<img src={'/product/org-chart/time.svg'} alt="Update" />
							<h3>Track your progress</h3>
							<p>See how data has evolved over time and track meaningful change.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/product/people-analytics/insight-v2.svg'} alt="Insight" />
							<h3>Easily shareable </h3>
							<p> Share trends without disclosing individual sensitive data.</p>
						</div>
					</div>
				</div>
            </section>

            {/* report */}
            <section className="sectionSpacing backgroundGradientContainer" id="report">
                <div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Centralize and collect data"
                        link="/product/people-analytics/Integration_reports-2.mp4"
                        type="video"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Report across any HR system. Integrate data from your HRIS, ATS and Equity & Performance Management tools.</p>
                                <p>Collect additional data through self ID surveys directly within ChartHop.</p>
                                <p>Go beyond EEOC standards with detailed race and ethnicity as well as non-binary gender and pronoun options.</p>
                            </React.Fragment>
                        }
                    />		
			    </div>
			</section>

		    {/* beyond */}
			<section className="sectionSpacing" id="beyond">
                <div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Visualize your people"
                        link="/videos/visualize-dei.mp4"
                        type="video"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>Go beyond the spreadsheets and graphs. Bring people data to life like never before.</p>
                                <p>Visualize any dimension directly on your org chart:</p>
                                <div className="row pb-0 pt-0">
                                    <div className="col-lg-6 col-md-12">
                                        <p className="mb-0">								
                                            <li>Gender</li>
                                            <li>Race & Ethnicity</li>
                                            <li>Intersectional Groups</li>
                                            <li>Sexual Orientation</li>
                                            <li>First Gen College Student</li>
                                        </p>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <p className="mb-0">	
                                            <li>Veteran status</li>
                                            <li>Disability</li>
                                            <li>Previously Incarcerated</li>
                                            <li>Highest Education Level</li>
                                            <li>Parents’ Education Level</li>		
                                        </p>
                                    </div>								
                                </div>
                            </React.Fragment>
                        }
                    />		
			    </div>
			</section> 

            {/* trends */}
            <section className="sectionSpacing backgroundGradientContainer" id="trends">
                <div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Analyze your trends"
                        link="/product/performance/reports-one-on-one-ethnicity.gif"
                        type="image"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>Understand your evolution through time-tracked changes and dissect your data across any dimension. Drill down into your data with the click of a button.</p>
                                <p>Access pre-built reports for your All Hands, Board decks, Management meetings and Recruiting updates. </p>
                                <p>Finally, spend less time gathering data and more time acting on it.</p>                               
                            </React.Fragment>
                        }
                    />		
			    </div>
			</section>

            <section className="sectionSpacing">
                <div className="contentBlock drive">
                    <h2 className="text-center mt-0 sectionSpacing-Margin">Drive a comprehensive DE&I Strategy</h2>
                    <h4 className="text-center sectionSpacing-Margin">Understand how key factors differ across genders, ethnicities, generations & more. </h4>
					<div className="pgc1">
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Cash Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Equity Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Total Compensation</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Levels & Titles</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Performance Reviews</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Promotions & Raises </p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Span of Control</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Engagement & Satisfaction </p>
                            </div>
                        </div>
                    </div>
					<p className="subListTitle mb-0 font-weight-bold text-center">& more</p>
				</div>
            </section>            

                {/* AVAILABLE INTEGRATIONS */}
                <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
                <h2 className="text-center mt-0 sectionSpacing-Margin">Built to augment your existing tools</h2>
                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack"/>
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>
                        {/* FIRST 4 */}

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* SECOND 4 */}

                        

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/gusto.png' alt="Gusto" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-rippling@2x.jpg' alt="Rippling" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div>      



                        {/* <div> */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">
                        </div>
                        {/* </div> */}
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>
            

            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"product-dei-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">"Companies spend millions trying to figure out if they have pay equity issues or gender gap issues.</p><p class=" mb-3 contact-testimonial">Now there will be no excuse because the data is sitting there -  you can push a button and get it."</p><div class="authorTag"><img src="/supporters/aileen-cowboy.png" class="testimonialAuthor" alt="Aileen Lee from Cowboy" /><div><p class="contactAuthor"><strong>Aileen Lee</strong> <br>Founder & Partner, Cowboy Ventures</p></div></div>')}/>
			</section>
        </Layout>
    );
};
export default Home;
